import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Grid } from '@mui/material';
import { IconButton, TextField } from '@totalsoft/rocket-ui';
import Save from '@mui/icons-material/Save';
import Delete from '@mui/icons-material/Delete';

const OfferAssetInformationComponent = ({
  t,
  idx,
  disabled,
  item,
  onPropertyChange,
  validationInfo,
  saveAssetInformation,
  dirtyInfo,
  deleteAssetInformation
}) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4} sm={6}>
        <TextField
          id={'assetInformationComponent_OrderNo' + idx}
          fullWidth
          disabled
          value={item.orderNo || ''}
          label={t('OfferEdit.AssetInformations.OrderNo')}
        />
      </Grid>
      <Grid item xs={12} md={4} sm={6}>
        <TextField
          id={'assetInformationComponent_OrderNumber' + idx}
          fullWidth
          disabled={disabled}
          value={item.orderNumber || ''}
          error={validationInfo.orderNumber}
          helperText={validationInfo.orderNumber}
          onChange={value => {
            onPropertyChange(item, 'orderNumber', value);
          }}
          label={t('OfferEdit.AssetInformations.OrderNumber')}
        />
      </Grid>
      <Grid item xs={12} md={4} sm={6}>
        <TextField
          id={'assetInformationComponent_ChassisNumber' + idx}
          fullWidth
          disabled={disabled}
          value={item.chassisNumber || ''}
          error={validationInfo.chassisNumber}
          helperText={validationInfo.chassisNumber}
          onChange={value => {
            onPropertyChange(item, 'chassisNumber', value);
          }}
          label={t('OfferEdit.AssetInformations.ChassisNo')}
        />
      </Grid>
      <Grid item xs={12} textAlign='end'>
        <IconButton
          id={'assetInformationComponent_delete' + idx}
          onClick={() => {
            deleteAssetInformation(item, idx);
          }}
          tooltip={t('Delete')}
          color='primary'
          variant='text'
          disabled={disabled || item.orderNo === 1}
        >
          <Delete />
        </IconButton>
        <IconButton
          id={'assetInformationComponent_save' + idx}
          tooltip={t('Save')}
          onClick={() => {
            saveAssetInformation(item);
          }}
          color='primary'
          variant='text'
          disabled={disabled || !dirtyInfo?.isDirty || !validationInfo.isValid}
        >
          <Save />
        </IconButton>
      </Grid>
    </Grid>
  );
};

OfferAssetInformationComponent.propTypes = {
  disabled: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
  saveAssetInformation: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  deleteAssetInformation: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  dirtyInfo: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default compose(withTranslation())(memo(OfferAssetInformationComponent));
